/**
 * Converte um token hexadecimal do design system em `rgba()`.
 *
 * Existe porque o MFE usava opacidade sobre token (`focus:ring-<cor>/30`) e o
 * PORTING.md proíbe hex literal em `styles.ts` — sem este helper, cada anel de
 * foco viraria um `rgba(216, 49, 67, .3)` escrito à mão, que deixa de acompanhar
 * o token se a paleta mudar.
 */
export function rgba(hex: string, alpha: number): string {
  const normalizado = hex.replace('#', '');
  const full =
    normalizado.length === 3
      ? normalizado
          .split('')
          .map((c) => c + c)
          .join('')
      : normalizado;

  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
